import {
  DateRangeFilter,
  ProjectsListFiltersValue,
} from 'types/store/projectsList';

export const BASE_URL = '/v3/projects';

export const PROJECT_LIST_TABS_KEYS = {
  ACTIVE_ITEMS: 'activeItems',
  TEAM_ITEMS: 'teamItems',
  MY_ITEMS: 'myItems',
} as const;

export const PROJECT_STATUS = {
  NEW: 'new',
  IN_PLANNING: 'in_planning',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELED: 'canceled',
  ON_HOLD: 'on_hold',
  CLOSED: 'closed',
} as const;

export const ACTIVE_PROJECTS_STATUSES = [
  PROJECT_STATUS.NEW,
  PROJECT_STATUS.IN_PLANNING,
  PROJECT_STATUS.IN_PROGRESS,
  PROJECT_STATUS.ON_HOLD,
] as const;

export const INACTIVE_PROJECTS_STATUSES = [
  PROJECT_STATUS.COMPLETED,
  PROJECT_STATUS.CANCELED,
  PROJECT_STATUS.CLOSED,
] as const;

export const PROJECT_PRIORITY = {
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
} as const;

export const PROJECT_HEALTH = {
  ON_TRACK: 'green',
  OFF_TRACK: 'red',
  AT_RISK: 'orange',
} as const;

export const PROJECT_RESOURCING_TYPE = {
  INTERNAL: 'internal',
  VENDOR: 'vendor',
  MIXED: 'mixed',
} as const;

export const PROJECT_PRIVACY = {
  PRIVATE: 'private',
  TEAM: 'team',
  PUBLIC: 'public',
} as const;

export const PROJECT_BUDGET_SOURCE = {
  LD: 'ld_budget',
  BUSINESS: 'business_budget',
  SPECIAL: 'special',
  MIXED: 'mixed',
  OTHERS: 'others',
} as const;

export const PROJECTS_TABLE_SORTABLE_COLUMNS = {
  PROJECT_NUMBER: 'displayId',
  PROJECT_NAME: 'name',
  STATUS: 'status',
  PRIORITY: 'priority',
  OWNERS: 'owners',
  HEALTH: 'health',
  PROGRAMS: 'programs',
  BUSINESS_UNIT: 'businessTeams',
  TEAMS: 'teams',
  CATEGORY: 'category',
  START_DATE: 'startDate',
  TARGET_COMPLETION_DATE: 'targetCompletionDate',
  ACTUAL_COMPLETION_DATE: 'actualCompletionDate',
  RESOURCING_TYPE: 'resourcingType',
  PROCESS: 'process',
  STAGE: 'stage',
  UPDATED_AT: 'updatedAt',
  QUICK_ACTIONS: 'quickActions',
  SELECT_ALL: 'selectAll',
} as const;

export const ACTIVE_PROJECTS_TABLE_SORTABLE_COLUMNS = [
  PROJECTS_TABLE_SORTABLE_COLUMNS.PROJECT_NUMBER,
  PROJECTS_TABLE_SORTABLE_COLUMNS.PROJECT_NAME,
  PROJECTS_TABLE_SORTABLE_COLUMNS.STATUS,
  PROJECTS_TABLE_SORTABLE_COLUMNS.OWNERS,
  PROJECTS_TABLE_SORTABLE_COLUMNS.START_DATE,
  PROJECTS_TABLE_SORTABLE_COLUMNS.TARGET_COMPLETION_DATE,
  PROJECTS_TABLE_SORTABLE_COLUMNS.UPDATED_AT,
] as const;

export const CONSOLIDATED_PROJECTS_TABLE_SORTABLE_COLUMNS = [
  PROJECTS_TABLE_SORTABLE_COLUMNS.SELECT_ALL,
  PROJECTS_TABLE_SORTABLE_COLUMNS.PROJECT_NUMBER,
  PROJECTS_TABLE_SORTABLE_COLUMNS.PROJECT_NAME,
  PROJECTS_TABLE_SORTABLE_COLUMNS.STATUS,
  PROJECTS_TABLE_SORTABLE_COLUMNS.PRIORITY,
  PROJECTS_TABLE_SORTABLE_COLUMNS.OWNERS,
  PROJECTS_TABLE_SORTABLE_COLUMNS.HEALTH,
  PROJECTS_TABLE_SORTABLE_COLUMNS.PROGRAMS,
  PROJECTS_TABLE_SORTABLE_COLUMNS.BUSINESS_UNIT,
  PROJECTS_TABLE_SORTABLE_COLUMNS.TEAMS,
  PROJECTS_TABLE_SORTABLE_COLUMNS.CATEGORY,
  PROJECTS_TABLE_SORTABLE_COLUMNS.START_DATE,
  PROJECTS_TABLE_SORTABLE_COLUMNS.TARGET_COMPLETION_DATE,
  PROJECTS_TABLE_SORTABLE_COLUMNS.ACTUAL_COMPLETION_DATE,
  PROJECTS_TABLE_SORTABLE_COLUMNS.UPDATED_AT,
  PROJECTS_TABLE_SORTABLE_COLUMNS.RESOURCING_TYPE,
  PROJECTS_TABLE_SORTABLE_COLUMNS.PROCESS,
  PROJECTS_TABLE_SORTABLE_COLUMNS.STAGE,
  PROJECTS_TABLE_SORTABLE_COLUMNS.QUICK_ACTIONS,
] as const;

export const ACTIVE_PROJECTS_FIELD_PARAM =
  'displayId,name,status,startDate,targetCompletionDate,permissions,updatedAt,taskCount,completedTaskCount';

export const CONSOLIDATED_PROJECTS_FIELD_PARAM =
  'displayId,name,status,priority,health,category,startDate,targetCompletionDate,actualCompletionDate,resourcingType,permissions,updatedAt,privacy,isArchived,taskCount,completedTaskCount';

export const CONSOLIDATED_PROJECTS_INCLUDE_PARAM =
  'owners,teams,businessTeams,programs,process,stage';

export enum QuickFilter {
  MY_PROJECTS = 'my',
  OPEN_PROJECTS = 'open',
}

export const DATE_RANGE_FILTER_KEYS = [
  'startDate',
  'targetCompletionDate',
  'actualCompletionDate',
];

export const isDateRangeFilterType = (
  filter: ProjectsListFiltersValue
): filter is DateRangeFilter => {
  return typeof filter === 'object' && ('min' in filter || 'max' in filter);
};
